import { supabase } from './supabase';

export async function sendPasswordRecovery(email: string): Promise<void> {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/reset-password`,
  });

  if (error) {
    throw new Error('Unable to send password reset instructions right now. Please try again.');
  }
}